// Common State.
const defaults = {
    sidebar: {
        visible: true,
    },
    title: '',
    layout: 'DefaultLayout',
    dialog: {
        visible: false,
        text: '',
    },
    snackbar: {
        visible: false,
        text: '',
        timeout: 6000,
        color: '',
    },
    error: {
        code: null,
        level: null,
        message: '',
    },
    loaderStateError: false,
};

// Global module loaded on first app load.
export default {
    namespaced: true,

    state: Object.assign({}, defaults),

    mutations: {
        updateSidebar(state, options) {
            state.sidebar = Object.assign({}, defaults.sidebar, options);
        },

        updateTitle(state, title) {
            state.title = title;
        },

        updateLayout(state, layout) {
            state.layout = layout;
        },

        updateDialog(state, options) {
            state.dialog = Object.assign({}, defaults.dialog, options);
        },

        updateSnackbar(state, options) {
            state.snackbar = Object.assign({}, defaults.snackbar, options);
        },

        updateLoader(state, loader) {
            state.loaderStateError = loader;
        },

        error(state, options) {
            state.error = Object.assign({}, defaults.error, options);
        },

        clear(state) {
            // eslint-disable-next-line no-unused-vars
            state = Object.assign({}, defaults);
        },
    },

    actions: {
        clear({ commit, dispatch }) {
            commit('clear');
            dispatch('auth/clear', {}, { root: true });
            // dispatch('mandant/clear', {}, { root: true });
        },

        updateSidebar({ commit }, options) {
            commit('updateSidebar', options);
        },

        updateTitle({ commit }, title) {
            commit('updateTitle', title);
        },

        updateLayout({ commit }, layout) {
            commit('updateLayout', layout);
        },

        updateDialog({ commit }, options) {
            commit('updateDialog', options);
        },

        updateSnackbar({ commit }, options) {
            commit('updateSnackbar', options);
        },

        updateLoader({ commit }, loader) {
            commit('updateLoader', loader);
        },
    },
    getters: {
        loaderState(state) {
            return state.loaderStateError;
        },
    },
};
